import { Box, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowDatePanel } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanel";
import { DateView } from "web_myplann/Shared/Types/DateView";

type Props = {
	value: Date | null;
	minDate?: Date;
	onSelect: (date: Date) => void;
	children?: ReactNode;
};

export const ReminderDateCalendar: FC<Props> = ({
	value,
	minDate,
	onSelect,
	children,
}) => {
	const { palette, spacingTokens, colors } = useTheme();
	const { t } = useResource();

	return (
		<Box
			px={spacingTokens.lg}
			pt={spacingTokens.md}
			pb={spacingTokens.sm}
			borderBottom={colors.border.solid(palette.surface.border)}
		>
			<Typography
				variant="caption"
				component="div"
				color={palette.grey[500]}
				mb={spacingTokens.sm}
			>
				{t(Resources.Reminders.Form.selectDate)}
			</Typography>
			{children}
			<FlatRowDatePanel
				value={value}
				mode={DateView.Day}
				minDate={minDate}
				onSelect={onSelect}
			/>
		</Box>
	);
};
